import { ICandidateEtab, IEtabCategory, ICandidateDashboardOffer, IQualification, ICandidateOfferSalary, ICandidateOfferAddress } from "@core/models";
import { CANDIDATES_OFFER_STATUS, CONTRACTS } from "@core/constants";

export const candidatePermanentOffersMock = [
  {
    [ICandidateDashboardOffer.id]: 34424349444001,
    [ICandidateDashboardOffer.startDate]: "2022-08-30",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-19 15:48:35",
    [ICandidateDashboardOffer.schedule]: "40h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Responsable point de vente / Administrateur hôtellerie",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Le Restaurant Du Bac à Sable d'Aulnay-sous-bois la vérité c'est long comme nom",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 33,
        [IEtabCategory.name]: "Salle de concert",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.amount]: 1550.55,
      [ICandidateOfferSalary.periodicity]: "Brut / Mois",
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "06000",
      [ICandidateOfferAddress.city]: "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
  {
    [ICandidateDashboardOffer.id]: 34433812532251,
    [ICandidateDashboardOffer.startDate]: "2022-08-29",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:03:24",
    [ICandidateDashboardOffer.schedule]: "20h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café Montparnasse -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 25,
        [IEtabCategory.name]: "Brasserie",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/23/55/0e/23550e81e178e7440505e383642e9f24.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Brut / Mois",
      [ICandidateOfferSalary.min]: 1250.25,
      [ICandidateOfferSalary.max]: 1750.72,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75014",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.CDI,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
  {
    [ICandidateDashboardOffer.id]: 34434369225001,
    [ICandidateDashboardOffer.startDate]: "2022-08-23",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:05:48",
    [ICandidateDashboardOffer.schedule]: undefined,
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Bricktop Pizza (Canal Saint-Martin) -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 42,
        [IEtabCategory.name]: "Pizzeria",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/bf/96/d4/bf96d4b69090bfdf3d24447f415aa4e3.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.amount]: 15,
      [ICandidateOfferSalary.periodicity]: "Brut / Heure",
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "69001",
      [ICandidateOfferAddress.city]: "Lyon",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.CDI,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
  {
    [ICandidateDashboardOffer.id]: 34439936400001,
    [ICandidateDashboardOffer.startDate]: "2022-08-31",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:56:14",
    [ICandidateDashboardOffer.schedule]: "25h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 55,
      [IQualification.qualificationLabel]: "Veilleur de nuit",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Brasserie du palace",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Restaurant Gastronomique",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/d5/b7/cc/d5b7cc26401bd97d348bc28b8e69418d.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Net / Mois",
      [ICandidateOfferSalary.amount]: 1250,
      [ICandidateOfferSalary.fluctuating]: false,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75013",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
  {
    [ICandidateDashboardOffer.id]: 34440493142251,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "35h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Brut / Heure",
      [ICandidateOfferSalary.min]: 12.25,
      [ICandidateOfferSalary.max]: 17.72,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
  {
    [ICandidateDashboardOffer.id]: 34441049889001,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:36",
    [ICandidateDashboardOffer.schedule]: undefined,
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Catégorie mauvaise annonce",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.fluctuating]: true,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.PENDING,
  },
];

export const candidatePermanentOffersAppliedMock = [
  {
    [ICandidateDashboardOffer.id]: 34440493142251,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:21",
    [ICandidateDashboardOffer.schedule]: "35h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 56,
      [IQualification.qualificationLabel]: "Linger",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café du théâtre -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café - Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Brut / Heure",
      [ICandidateOfferSalary.min]: 12.25,
      [ICandidateOfferSalary.max]: 17.72,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75010",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.APPLIED,
  },
  {
    [ICandidateDashboardOffer.id]: 34441049889001,
    [ICandidateDashboardOffer.startDate]: "2022-09-07",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:58:36",
    [ICandidateDashboardOffer.schedule]: undefined,
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Catégorie mauvaise annonce",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.fluctuating]: true,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.APPLIED,
  },
];

export const candidatePermanentOffersSelectedMock = [
  {
    [ICandidateDashboardOffer.id]: 34434369225001,
    [ICandidateDashboardOffer.startDate]: "2022-08-23",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:05:48",
    [ICandidateDashboardOffer.schedule]: undefined,
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Bricktop Pizza (Canal Saint-Martin) -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 42,
        [IEtabCategory.name]: "Pizzeria",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/bf/96/d4/bf96d4b69090bfdf3d24447f415aa4e3.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.amount]: 15,
      [ICandidateOfferSalary.periodicity]: "Brut / Heure",
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "69001",
      [ICandidateOfferAddress.city]: "Lyon",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.CDI,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
  {
    [ICandidateDashboardOffer.id]: 34439936400001,
    [ICandidateDashboardOffer.startDate]: "2022-08-31",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-29 15:56:14",
    [ICandidateDashboardOffer.schedule]: "25h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 55,
      [IQualification.qualificationLabel]: "Veilleur de nuit",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Brasserie du palace",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Restaurant Gastronomique",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/d5/b7/cc/d5b7cc26401bd97d348bc28b8e69418d.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Net / Mois",
      [ICandidateOfferSalary.amount]: 1250,
      [ICandidateOfferSalary.fluctuating]: false,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75013",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.SELECTED,
  },
];

export const candidatePermanentOffersRefusedMock = [
  {
    [ICandidateDashboardOffer.id]: 34424349444001,
    [ICandidateDashboardOffer.startDate]: "2022-08-30",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-19 15:48:35",
    [ICandidateDashboardOffer.schedule]: "40h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Responsable point de vente / Administrateur hôtellerie",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "Le Restaurant Du Bac à Sable d'Aulnay-sous-bois la vérité c'est long comme nom",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 33,
        [IEtabCategory.name]: "Salle de concert",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.amount]: 1550.55,
      [ICandidateOfferSalary.periodicity]: "Brut / Mois",
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "06000",
      [ICandidateOfferAddress.city]: "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.SEASON,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.REFUSED,
  },
  {
    [ICandidateDashboardOffer.id]: 34433812532251,
    [ICandidateDashboardOffer.startDate]: "2022-08-29",
    [ICandidateDashboardOffer.publicationDate]: "2022-08-23 18:03:24",
    [ICandidateDashboardOffer.schedule]: "20h/semaine",
    [ICandidateDashboardOffer.qualification]: {
      [IQualification.qualificationId]: 2,
      [IQualification.qualificationLabel]: "Serveur",
    },
    [ICandidateDashboardOffer.etab]: {
      [ICandidateEtab.name]: "- Café Montparnasse -",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 25,
        [IEtabCategory.name]: "Brasserie",
      },
      [ICandidateEtab.pictures]: ["https://s3-eu-west-1.amazonaws.com/extraprd/23/55/0e/23550e81e178e7440505e383642e9f24.jpg"],
    },
    [ICandidateDashboardOffer.salary]: {
      [ICandidateOfferSalary.periodicity]: "Brut / Mois",
      [ICandidateOfferSalary.min]: 1250.25,
      [ICandidateOfferSalary.max]: 1750.72,
    },
    [ICandidateDashboardOffer.address]: {
      [ICandidateOfferAddress.postalCode]: "75014",
      [ICandidateOfferAddress.city]: "Paris",
    },
    [ICandidateDashboardOffer.contractType]: CONTRACTS.CDI,
    [ICandidateDashboardOffer.status]: CANDIDATES_OFFER_STATUS.REFUSED,
  },
];
